import { useState, useEffect } from 'react';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent, shouldOpenInNewTab } from '@Components/Utilities/SandhillsUtility';
import { useRecoilState, useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import ready from 'document-ready';
import translator from '@Components/Utilities/Translator';

const ValueInsightPortalButton = (props) => {

	const [isVisible, setIsVisible] = useState(false);
	const currentSite = useRecoilValue(atoms.currentWebsite);

    useEffect(() => {
		ready(() => {
			setTimeout(() => {
				const hasListingControlBar = document.getElementsByClassName('listing-control-bar').length > 0;
				const hasMobileListingControlBar = document.getElementsByClassName('mobile-listing-control-bar').length > 0;
				setIsVisible(!(hasListingControlBar || hasMobileListingControlBar));
			}, 2000);
		});
	}, []);

	return (isVisible &&
		<div className={props.IsAircraftValuationButton ? 'av-floating-cta' : 'vip-floating-cta' + ' cf no-print'}>
			<a id={props.IsAircraftValuationButton ? 'av-floating-button' : props.IsVipPlusButton ? 'vip-floating-button' : 'vip-button'} rel='nofollow' className={props.IsAircraftValuationButton ? 'av-floating-cta-btn' : 'vip-floating-cta-btn'} href={props.VipPortalUrl} target={shouldOpenInNewTab(props.VipPortalUrl) ? '_blank' : '_self'} title={props.VipPortalTitle} onClick={() => gtmPushEvent(gtmEventType.vip)} aria-label={shouldOpenInNewTab(props.VipPortalUrl) ? props.VipPortalTitle + " (" + translator.translate('sandhills.opensinanewtab') + ")" : props.VipPortalTitle}>
				<img className={props.IsAircraftValuationButton ? 'aircraft-valuation-img' : props.IsVipPlusButton ? 'vip-plus-img' : 'vip-img'}  src={props.VipPortalImage} alt={props.VipPortalAltText} />
			</a>
		</div>
    );
};

export default ValueInsightPortalButton;
global.ValueInsightPortalButton = ValueInsightPortalButton;